/** проверяет корректность передаваемой даты как строки так и Date object */
export function gasCheckDate(currentDate: string): boolean {
  if (typeof currentDate === 'object') {
    if (!new Date(currentDate).getDate()) {
      return false;
    } else {
      return true;
    }
  } else {
    const date = currentDate
      .split('.')
      .reverse()
      .join('-');

    /** если для полученной даты getDate возвращает NaN - значит такой даты не существует*/
    if (!new Date(date).getDate()) {
      return false;
    }
    return true;
  }
};

/** удаляем все датапикеры со страницы */
export function removeDuble(): void {
  document.querySelectorAll('gas-datepicker').forEach(datapicker => datapicker.remove());
};

const MAX_TIMES = {
  hours: 23,
  minutes: 59,
  seconds: 59,
};
/** проверяет время и подставляет максимальные значения, если введеные пользователем превышают их */
export function checkCurrentTime(times: string[]): string {
  if (+times[0] > MAX_TIMES.hours) {
    times[0] = `${MAX_TIMES.hours}`;
  }
  if (+times[1] > MAX_TIMES.minutes) {
    times[1] = `${MAX_TIMES.minutes}`;
  }
  if (+times[2] > MAX_TIMES.seconds) {
    times[2] = `${MAX_TIMES.seconds}`;
  }

  return times.join(':');
}

export function addZero(value: number): string {
  return value < 10 ? `0${value}` : value.toString();
}
